import React, { useState, useEffect } from 'react';
import { Button, Select } from 'antd';
import {
  LeftOutlined,
  RightOutlined,
  DeleteOutlined,
  CheckCircleFilled,
  EditOutlined
} from '@ant-design/icons';

import './style';

export default React.forwardRef((props, ref) => {
  const { onNew, emptyContent, renderItem, selected, onSelected, onDelete, onEdit, title, rows, footer, selectable } = props;
  const [pagination, setPagination] = useState({ limit: 10, offset: 0 });
  const [page, setPage] = useState(0);

  //const [selected, setSelected] = useState(selected || 0);
  useEffect(() => {
    if (rows.length > 0) {
      if (onSelected) {
        onSelected(0);
      }
    }
  }, []);

  useEffect(() => {
    const pageCount = Math.ceil(rows.length / pagination.limit);
    if (page > pageCount - 1) {
      setPage(0);
    }
  }, [rows]);

  const onSelectRow = (index) => {
    if (onSelected) {
      onSelected(index);
      //setSelected(index);
    }
  }

  const renderPage = () => {
    const arr = [];
    const pageCount = Math.ceil(rows.length / pagination.limit);
    if (rows.length > 10) {
      arr.push(<span style={{ marginRight: '1.5rem' }}>,&nbsp;每页显示&nbsp;<Select
        onChange={onChangePagination} value={pagination.limit}
        size="small">
        <Select.Option value={10}>10</Select.Option>
        {rows.length > 10 && <Select.Option value={20}>20</Select.Option>}
        {rows.length > 20 && <Select.Option value={30}>30</Select.Option>}
        {rows.length > 30 && <Select.Option value={50}>50</Select.Option>}
        {rows.length > 50 && <Select.Option value={100}>100</Select.Option>}
      </Select>&nbsp;条</span>)
    }
    if (pageCount <= 1) {
      return arr;
    }
    if (pageCount > 1) {
      arr.push(
        <span>
          <Button size="small" disabled={page === 0} onClick={onPrePage} type="link" icon={<LeftOutlined />}></Button>
          <Button size="small">{page + 1}</Button>
          <Button size="small" disabled={page === pageCount - 1} onClick={onNextPage} type="link" icon={<RightOutlined />}></Button>
        </span>);
    }
    return arr;
  }
  const onPrePage = () => {
    if (page > 0) {
      setPage(page - 1);
    }
  }
  const onNextPage = () => {
    const pageCount = Math.ceil(rows.length / pagination.limit);
    if (page < pageCount - 1) {
      setPage(page + 1);
    }
  }
  const onChangePagination = (value) => {
    setPagination({ limit: value, offset: 0 });
    setPage(0);
  }

  return (
    <div className="list-container">
      {
        title && <div className="list-container-header">
          {title}
        </div>
      }
      {
        rows.length === 0 && <div className="list-container-nocontent">
          {emptyContent}
        </div>
      }
      {
        rows.map((item, index) => {
          if (index < (page) * pagination.limit) return undefined;
          if (index > (page + 1) * pagination.limit - 1) return undefined;
          return <div onClick={() => onSelectRow(index)} className={`list-container-item ${selectable === true && selected === index ? "selected" : ""}`}>
            {renderItem && renderItem(item, index)}
            {item.editable && <Button onClick={() => onEdit(index, item)} size="small" type="link" icon={<EditOutlined />}></Button>}
            {item.deletable && <Button onClick={() => onDelete(index, item)} size="small" danger type="link" icon={<DeleteOutlined />}></Button>}
            {item.showCompleted && <Button style={{ marginLeft: 'auto', }} size="small" type="link" icon={<CheckCircleFilled style={{ color: '#52c41a' }}></CheckCircleFilled>}></Button>}
          </div>
        })
      }
      {
        rows.length > 0 && footer && <div className="list-container-footer">
          {renderPage()}
          共{rows.length}项
      </div>
      }

    </div>
  );
});
